import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageClass = () => {
    const location = useLocation();

    useEffect(() => {
        // Get pathname and remove leading slash
        console.log('use effect works')
        const path = location.pathname.substring(1);

        // Convert path to class name
        const pageClass = path ? `page-${path}` : 'page-home';

        // Ensure the initial class is set before effect runs
        document.body.classList.forEach(cls => {
            if (cls.startsWith('page-')) {
                document.body.classList.remove(cls);
            }
        });
        document.body.classList.add(pageClass);

        // Cleanup function to remove the class
        return () => {
            document.body.classList.remove(pageClass);
        };
    }, [location.pathname]);
};
